const EXTERNAL_SEARCH_CONFIG = {
  enabled: /true/i.test(process.env.NEXT_PUBLIC_ENABLE_SEARCH_INDEX ?? ''),
  nodes:
    process.env.NEXT_PUBLIC_SEARCH_INDEX_HOSTPORTS?.split(',').map(
      (hostport) => {
        const [host, port] = hostport.split(':')
        return {
          host,
          port: +(port ?? 0),
          protocol: 'http',
        }
      }
    ) ?? [],
  apiKey: process.env.NEXT_PUBLIC_SEARCH_INDEX_API_KEY ?? '',
}

export default EXTERNAL_SEARCH_CONFIG
